export default "__VITE_ASSET__ZZZg7_QW__"